import React, { useEffect } from "react";

import Title from "../../../atoms/proc-management/title";
import { RBACHidden } from "../../../helpers/rbac/rbac";
import { SecondaryButton, TextField } from "@graffer-inc/console-design-kit";
import { Shortcut } from "../../../../application/domain/ttzk-portal";
import { TtzkPortalR } from "../../../pages/ttzk-portal/route";
import { useHistory } from "react-router-dom";
import { PublishButton } from "../../../atoms/ttzk-portal/publish-button";
import { emptyFunction } from "../../../../utils/function-utils";

type Props = {
  shortcutId: string;
  shortcut: Shortcut;
  fetchShortcutByID: (shortcutId: string) => Promise<void>;
  onPublish: () => void;
  onUnPublish: () => void;
};

export const ShortcutDetail: React.FC<Props> = ({
  shortcutId,
  shortcut,
  fetchShortcutByID,
  onPublish,
  onUnPublish,
}) => {
  const history = useHistory();

  useEffect(() => {
    fetchShortcutByID(shortcutId);
  }, []);

  return (
    <>
      <Title text={shortcut.name ? shortcut.name : ""} />
      <hr className="my-3" />
      <div className="columns">
        <div className="column has-text-right buttons">
          <RBACHidden requirePermissions="ttzk_portal.shortcuts.update">
            <PublishButton
              shortcut={shortcut}
              onPublish={onPublish}
              onUnPublish={onUnPublish}
            />
            <SecondaryButton
              text="ショートカット編集"
              onClick={() => {
                history.push(TtzkPortalR.ShortcutEdit.link({ shortcutId }));
              }}
            />
          </RBACHidden>
        </div>
      </div>
      <div className="field">
        <TextField
          label={"説明"}
          description=""
          placeholder={""}
          onChange={emptyFunction}
          value={shortcut.description}
          readOnly={true}
          required={true}
        />
      </div>
      <div className="field">
        <TextField
          label={"公開ステータス"}
          description=""
          placeholder={""}
          onChange={emptyFunction}
          value={shortcut.isPublished ? "公開中" : "下書き"}
          readOnly={true}
          required={true}
        />
      </div>
      <div className="field">
        <TextField
          label={"表示順"}
          description=""
          placeholder={""}
          onChange={emptyFunction}
          value={shortcut.priority}
          readOnly={true}
          required={true}
        />
      </div>
      <div className="field">
        <TextField
          label={"URL"}
          description=""
          placeholder={""}
          onChange={emptyFunction}
          value={shortcut.url}
          readOnly={true}
          required={true}
        />
      </div>
      <div className="field">
        <TextField
          label={"画像"}
          description=""
          placeholder={""}
          onChange={emptyFunction}
          value={shortcut.imageUrl}
          readOnly={true}
          required={true}
        />
      </div>
      <div
        style={{
          width: "300px",
        }}
      >
        <figure className="image is-2by1">
          <img
            src={shortcut.imageUrl}
            style={{
              objectFit: "cover",
            }}
            alt="shortcutImage"
          />
        </figure>
      </div>
    </>
  );
};

export default ShortcutDetail;
